import { Component, Input, Output, EventEmitter } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';

export interface ProgressStep {
  label: string;
  status?: 'complete' | 'active' | 'upcoming' | 'error';
  color?: string; // e.g. 'green', 'red', etc.
  sectionId?: string; // Optional: used for navigation
}

@Component({
  selector: 'claims-app-progress-step',
  templateUrl: './claims-app-progress-step.component.html',
  styleUrl: './claims-app-progress-step.component.scss',
  animations: [
    trigger('stepState', [
      state('void', style({
        backgroundColor: '#fff',
        borderColor: '#ccc'
      })),
      state('active', style({
        backgroundColor: '#ffeb3b',
        borderColor: '#ffeb3b'
      })),
      state('complete', style({
        backgroundColor: '#8bc34a',
        borderColor: '#8bc34a'
      })),
      state('error', style({
        backgroundColor: '#e57373',
        borderColor: '#e57373'
      })),
      state('upcoming', style({
        backgroundColor: '#fff',
        borderColor: '#ccc'
      })),
      transition('void => *', [
        style({
          backgroundColor: '#fff',
          borderColor: '#ccc'
        }),
        animate('0s')
      ]),
      transition('active => complete', [
        animate('5s ease-in-out')
      ]),
      transition('active => error', [
        animate('5s ease-in-out')
      ]),
      transition('error => complete', [
        animate('5s ease-in-out')
      ]),
      transition('upcoming => active', [
        animate('5s ease-in-out')
      ]),
      transition('complete => active', [
        animate('5s ease-in-out')
      ]),
      transition('error => active', [
        animate('5s ease-in-out')
      ])
    ])
  ]
})
export class ClaimsAppProgressStepComponent {
  @Input() steps: ProgressStep[] = [];
  @Input() activeIndex: number = 0;
  @Input() laborTotal: number = 0;
  @Input() partTotal: number = 0;
  @Input() supplyTotal: number = 0;
  @Output() stepClick = new EventEmitter<number>();

  onStepClick(index: number) {
    this.stepClick.emit(index);
  }
}
